module.exports = __webpack_public_path__ + "img/skrill.710e5326.png";